import { PATH_ACTIVATE, REG_CODE_MIN_LENGTH, REG_CODE_REGEX } from 'constants/index';

export const isRegCode = (value = ''): boolean =>
  value.length >= REG_CODE_MIN_LENGTH && REG_CODE_REGEX.test(value);

export const sanitizeRegCode = (value = ''): string =>
  value.toUpperCase().replace(/[^A-Z0-9]/g, '');

// Takes a pathname, never location.href: href keeps the query string glued to
// the code until the trailing slash is normalized in. '' means "let them type".
export const getRegCodeFromPath = (pathname = ''): string => {
  if (!pathname.startsWith(PATH_ACTIVATE)) return '';

  const segments = pathname.slice(PATH_ACTIVATE.length).split('/').filter(Boolean);
  if (segments.length !== 1) return '';

  const code = segments[0].toUpperCase();
  return isRegCode(code) ? code : '';
};
